import axios from "axios";
import { api } from "./helper";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "pkiqs5pdcp";
  return config;
});







function Login(item) {
  return client.post("SystemAuth/Login", item);
}
function Systems(item) {
  return client.post("SystemAuth/Systems", item);
}
function UserName() {
  return client.post("SystemAuth/UserName");
}







export default {
  Login,
  Systems,
  UserName
};
